import { render, staticRenderFns } from "./reset-scene.vue?vue&type=template&id=95493320&"
import script from "./reset-scene.vue?vue&type=script&lang=js&"
export * from "./reset-scene.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports